module.exports = __webpack_public_path__ + "static/media/Flowers.16dcf257.jpg";